import { getEnumMemberName } from 'utils/helpers'
import { augmentIncomingCreativeMedia } from '../../components/Recommendations/Campaign/Media/mediaPayload'
import { TARGETING_MODES } from 'components/Recommendations/Campaign/Edit/CampaignForm/Targeting/targeting'

export const generativeCreativeField = Object.freeze({
  headlines: 'headlines',
  bodies: 'bodies',
  description: 'description',
})

export function parseSetupProcess(data, eventId) {
  const targeting = []
  if (data.targeting) {
    for (const tcTargeting of data.targeting) {
      if (
        [TARGETING_MODES.postalCodes, TARGETING_MODES.rangeLocations].includes(
          tcTargeting.targeting_mode,
        )
      ) {
        targeting.push({
          tc: tcTargeting.tc,
          tc_run_id: tcTargeting.tc_run_id,
          targetingMode: tcTargeting.targeting_mode,
          postalCodes: tcTargeting['postal-codes'],
          rangeLocations: tcTargeting['range-locations'],
          ageRange: tcTargeting['age_range'],
        })
      } else {
        targeting.push({
          tc: tcTargeting.tc,
          tc_run_id: tcTargeting.tc_run_id,
          targetingMode: TARGETING_MODES.fdTargeting,
          ageRange: tcTargeting['age_range'],
        })
      }
      
      // set age targeting if not set
      const currentTargeting = targeting.find(
        (x) => x.tc === tcTargeting.tc && x.tc_run_id === tcTargeting.tc_run_id,
      )
      if (!currentTargeting.ageRange) {
        currentTargeting.ageRange = {
          min: 18,
          max: 65,
        }
      }
    }
  }

  if (!data.targeting?.length) {
    const tcs = data.creatives?.map((x) => x.tc) || []
    for (const tc of tcs) {
      targeting.push({
        tc,
        ageRange: {max: 65, min: 18},
      })
    }
  }

  // ---
  // Problem: When propagating destination_url changes between taste clusters (TCs),
  // we need to distinguish between TCs whose destination_url was set by the user (manually edited)
  // and those that are just inheriting the value from another TC. Otherwise, TCs loaded from the server
  // with a non-empty destination_url would be incorrectly considered as inherited and overwritten on the first edit.
  //
  // Solution: On initial parse from the server, mark any creative with a non-empty destination_url as
  // destination_url_inherited: false. This ensures only truly inherited (empty) destination_urls are updated
  // by propagation logic. This flag is not sent to the server and is only used client-side.
  // ---
  const result = {
    ...data,
    goal: getEnumMemberName(data.goal),
    creatives: (data.creatives ?? []).map((x) => {
      // If a creative has a non-empty destination_url, mark it as not inherited
      const hasNonEmptyUrl = Array.isArray(x.destination_url) && x.destination_url.filter(Boolean).length > 0
      const mergedMedia = augmentIncomingCreativeMedia({
        media: x.media ?? [],
        placement_media: x.placement_media ?? [],
      })

      return {
        ...x,
        media: mergedMedia,
        placement_media: [],
        excluded_variations: x.excluded_variations ?? [],
        // Mark as not inherited if destination_url is present
        ...(hasNonEmptyUrl ? { destination_url_inherited: false } : {}),
      }
    }),
    targeting,
    eid: eventId,
  }

  return result
}

export function getDisabledVariationsFromCreatives(creatives) {
  return [creatives].flat().reduce((acc, c) => {
    acc[c.tc] = c.excluded_variations || []
    return acc
  }, {})
}
